export default __webpack_public_path__ + "static/media/IMG_0049.c0761faf.jpg";